import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Gift } from 'lucide-react';
export function ForYouIf() {
  const points = ['🎤 Content Creation Microphone', '🎟 2 Tickets to the In Bloom Women & Wellness Mixer'];
  return <section className="py-24 bg-maroon relative overflow-hidden" data-id="element-61">
      <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-blush/5 blur-[100px] rounded-full pointer-events-none" data-id="element-62"></div>

      <div className="max-w-3xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-63">
        <FadeIn className="text-center mb-12" data-id="element-64">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blush/15 mb-6 border border-blush/20" data-id="element-65">
            <Gift className="w-8 h-8 text-blush" data-id="element-66" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" data-id="element-67">
            🎁 Member Giveaway (April 30)
          </h2>
          <p className="text-xl text-blush-light font-serif italic" data-id="element-68">
            Join before April 30 for a chance to win:
          </p>
        </FadeIn>

        <StaggerContainer className="space-y-5 mb-10" data-id="element-69">
          {points.map((point, index) => <StaggerItem key={index} className="flex items-center bg-white/[0.06] backdrop-blur-sm p-6 rounded-xl border border-blush/15" data-id="element-70">
              <span className="text-xl md:text-2xl text-cream font-medium" data-id="element-71">
                {point}
              </span>
            </StaggerItem>)}
        </StaggerContainer>

        <FadeIn delay={0.2} className="text-center" data-id="element-72">
          <p className="text-sm text-blush/70 uppercase tracking-widest" data-id="element-73">
            Must be an active member to qualify
          </p>
        </FadeIn>
      </div>
    </section>;
}